import BannerItemSmall from './BannerItemSmall';

export default BannerItemSmall;
